import Bus from 'vue';

var install = function install(Vue) {
  Vue.prototype.$bus = new Bus();
};

export default {
  install: install
};